import Environment from '../../Environment';
import { IFilter, buildUrl } from '../BaseService';

export interface IPreparePlayerPromptUrl {
  filters: IFilter[];
}

export function preparePlayerPromptUrl({
  filters,
}: IPreparePlayerPromptUrl): string {
  return buildUrl({
    host: Environment.mediaService,
    resource: 'player-prompts',
    filters,
  });
}
